import { Severity } from '@rtls/core/models/shared/severity';
import { stopFactory } from '@rtls/core/models/transports/stop.factory';
import { TransportProgress } from '@rtls/core/models/transports/transport-progress.model';
import { randomFrom, randomNumber } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const transportProgressFactory = Factory.makeFactory<TransportProgress>({
	delay: Factory.each(() => randomNumber(false)),
	progressPercentage: Factory.each(() => randomNumber(false)),
	severity: Factory.each(() => randomFrom([Severity.WARN, Severity.DANGER, Severity.INTERMEDIATE])),
	stop: Factory.each(() => stopFactory.build()),
	nextStop: Factory.each(() => stopFactory.build()),
	stopEventType: Factory.each(() => randomFrom(['IN', 'OUT'])),
});
